<template>
  <div class="card card-body shadow-sm">
    <app-basic-table
      ref="basic_table"
      :table-name="$t('users.user list')"
      :filters.sync="filters"
      :setting-columns="columns"
      :endpoint-list="ENDPOINT.GATEWAY_LIST"
      @resetAllSearch="onResetAllSearch"
      @searched="onSearch"
    >
      <template v-slot:filters>
        <div class="row mt-3">
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group row">
              <div class="col-xl-12 col-lg-12 col-sm-12  mt-0">
                <label class="align-self-center mb-0 mr-5">{{ filters.status_equal.label }}</label>
              </div>
              <div class="col-xl-12 col-lg-12 col-sm-12  mt-3">
                <app-radio v-for="(item, index) in BEACONS_CONSTANT.FILTER_STATUS"
                           :isMarginLeft="index !=0 ? true : false" :key="item.id" :label="item.name"
                           :val="item.id" v-model="filters.status_equal.value"/>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group row">
              <div class="col-xl-12 col-lg-3 col-sm-3  mt-0">
                <label>{{ filters.apartment_id_equal.label }}</label>
              </div>
              <div class="col-xl-12 col-lg-9 col-sm-9  mt-0">
                <app-select :name="filters.apartment_id_equal.name"
                            input-style="normal"
                            v-model="filters.apartment_id_equal.value"
                            :options-data="meta.apartments"
                />
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group row">
              <div class="col-xl-12 col-lg-3 col-sm-3  mt-0">
                <label>{{ filters.facility_id_equal.label }}</label>
              </div>
              <div class="col-xl-12 col-lg-9 col-sm-9  mt-0">
                <app-select :name="filters.facility_id_equal.name"
                            input-style="normal"
                            v-model="filters.facility_id_equal.value"
                            :options-data="meta.facilities"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label>{{ filters.name_equal.label }}</label>
              <app-input :name="filters.name_equal.name" input-style="normal"
                         v-model="filters.name_equal.value"
              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label>{{ filters.mac_id_like.label }}</label>
              <app-input :name="filters.mac_id_like.name" input-style="normal"
                         v-model="filters.mac_id_like.value"
              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4">
            <div class="form-group">
              <label>{{ filters.serial_equal.label }}</label>
              <app-input :name="filters.serial_equal.name" input-style="normal"
                         v-model="filters.serial_equal.value"
              />
            </div>
          </div>

        </div>
      </template>


      <template v-slot:body-cell-apartment_id="props">
        <td class="app-align-middle">
          <p :data-original-title="props.row.apartment_name" style="color: #007bff;"
             @click="handlerApartmentNameClick(props.row)" class="apartment_name app-table-p app-cell-tooltip mb-0">
            {{props.row.apartment_name}}
          </p>
        </td>
      </template>

      <template v-slot:body-cell-facility_id="props">
        <td class="app-align-middle">
          <p :data-original-title="props.row.facility_name" style="color: #007bff;"
             @click="handlerFacilityNamClick(props.row)" class="apartment_name app-table-p app-cell-tooltip mb-0">
            {{props.row.facility_name}}
          </p>
        </td>
      </template>

      <template v-slot:table-menu-right>
        <button @click="handleBtnCreateClick()" class="btn btn-warning">
          {{ $t("common.create") }}
        </button>
      </template>

      <template v-slot:body-cell-edit="props">
        <td class="app-align-middle text-center app-p-none">
          <button
            @click="handleBtnUpdateClick(props.row)"
            class="btn btn-primary"
          >
            {{ $t("common.edit") }}
          </button>
        </td>
      </template>


      <template v-slot:body-cell-status_enabled="props">
        <td class="app-align-middle">
          <p class="app-table-p app-cell-tooltip mb-0" >
            {{getStatusEnabled(props.row.status_enabled)}}
          </p>
        </td>
      </template>

      <template v-slot:body-cell-history="props">
        <td class="app-align-middle text-center app-p-none">
          <button
            @click="handleBtnHistoryClick(props.row)"
            class="btn btn-primary"
          >
            {{ $t("beacons.history") }}
          </button>
        </td>
      </template>

    </app-basic-table>

    <!--    <create-component-->
    <!--      ref="modal_create"-->
    <!--      @onSuccess="handleCreateSuccess"-->
    <!--    ></create-component>-->

    <!--    <update-component-->
    <!--      @onSuccess="handleUpdateSuccess"-->
    <!--      ref="modal_update"-->
    <!--    ></update-component>-->

  </div>
</template>

<script>
  import AppBasicTable from "@components/_common/list/AppBasicTable";
  import AppDateRangePicker from "../../../components/forms/AppDateRangepicker";
  import {ENDPOINT} from "../../../constants/api";
  import {FACILITIES_CONSTANT} from "../../../constants/facilities";
  import {BEACONS_CONSTANT} from "../../../constants/beacons";
  import {GATEWAY_CONSTANT} from "../../../constants/gateway";

  export default {
    name: "GateWayListPage",
    components: {
      "app-basic-table": AppBasicTable,
      AppDateRangePicker,
    },
    data() {
      return {
        idCache: null,
        paramGetList: {},
        filters: {
          apartment_id_equal: {
            name: "apartment_id_equal",
            condition: "equal",
            label: this.$t("common.mansion")
          },
          facility_id_equal: {
            name: "facility_id",
            condition: "equal",
            label: this.$t("common.facility")
          },
          serial_equal: {
            name: "serial_like",
            condition: "like",
            label: this.$t("beacons.serial")
          },
          mac_id_like: {
            name: "mac_id_like",
            condition: "like",
            label: this.$t("gateway.mac_id")
          },
          name_equal: {
            name: "name_like",
            condition: "like",
            label: this.$t("beacons.name")
          },
          status_equal: {
            name: "status_enabled",
            condition: "equal",
            label: this.$t("beacons.status")
          },
        },
        columns: [
          {name: "id", label: this.$t("common.id"), sortable: true, textAlign: 'text-center'},
          {name: "name", label: this.$t("gateway.name"), sortable: true},
          {name: "serial", label: this.$t("gateway.mac_id")},
          {name: "mac_id", label: this.$t("gateway.serial")},
          {name: "signal", label: this.$t("gateway.signal"), sortable: true ,textAlign: 'text-center'},
          {name: "status_enabled", label: this.$t("gateway.status_active"), sortable: true},
          {
            name: "apartment_id",
            label: this.$t("gateway.mansion"),
            sortable: true,
          },
          {name: "fetched_at", label: this.$t("gateway.fetched_at"), sortable: true, textAlign: 'text-center'},
          {name: "facility_id", label: this.$t("gateway.facility"), sortable: true},
          {name: "history", label: this.$t("gateway.history"), textAlign: 'text-center'},
          {name: "edit", label: this.$t("common.edit"), textAlign: 'text-center'},
        ],
        meta: {
          apartments: [],
          facilities: []
        },
        endPoint: ''
      };
    },
    watch: {
      'filters.apartment_id_equal.value': function (value, oldValue) {
            this.getMetaData({apartment_id : value})
      }
    },
    methods: {
      async getMetaData(params) {
        await this.$request.get(this.ENDPOINT.UI_HELPER_GATEWAYS, params).then(res => {
          this.meta = {
            apartments: res.data.apartments,
            facilities: res.data.facilities
          }
          this.meta.apartments.unshift({
            id: "all",
            name: ""
          })
          this.meta.facilities.unshift({
            id: "all",
            name: ""
          })
          let vm = this
          if (!this.meta.facilities.find(({id}) => id === parseInt(vm.filters.facility_id_equal.value))) {
            this.filters.facility_id_equal.value = 'all';
          }
        })
      },
      async handleBtnBackClick() {
        await this.$router.push({
          name: this.ROUTES.ADMIN.GATEWAY_LIST,
          query: {
            'filters.status_enabled.equal': 'all',
            'filters.apartment_id.equal': 'all',
            'filters.facility_id.equal' : 'all'
          }
        });
      },
      handleBtnCreateClick() {
        this.$router.push({name: this.ROUTES.ADMIN.GATEWAY_CREATE})
      },
      handleBtnUpdateClick(entry) {
        this.$router.push({name: this.ROUTES.ADMIN.GATEWAY_EDIT, params: {id: entry.id}})
      },
      handleBtnHistoryClick(entry) {
        this.$router.push({name: this.ROUTES.ADMIN.GATEWAY_HISTORY_LIST, params: {id: entry.serial},  query : {
            'filters.date.equal' : moment().format('YYYY-MM-DD')
          }})
      },
      handlerApartmentNameClick(entry) {
        let routeApartment = this.$router.resolve({name: this.ROUTES.ADMIN.APARTMENT_EDIT, params: {id: entry.apartment_id}});
        window.open(routeApartment.href, '_blank');
      },
      handlerFacilityNamClick(entry) {
        let routeFacility = this.$router.resolve({name: this.ROUTES.ADMIN.FACILITY_EDIT, params: {id: entry.facility_id}});
        window.open(routeFacility.href, '_blank');
      },

      getStatusEnabled(status) {
        let data = GATEWAY_CONSTANT.STATUS_ACTIVE.find(({id}) => id === status);
        return data.name
      },

      onResetAllSearch() {
        this.$router.push({
          name: this.ROUTES.ADMIN.GATEWAY_LIST, query: {
            'filters.status_enabled.equal': 'all',
            'filters.apartment_id_equal.equal' : 'all',
            'filters.facility_id.equal' : 'all'
          }
        })
      },
      onSearch() {
        // this.getTourSelectName();
      },
    },
    mounted: async function () {
      // this.getParamsFilters({})
    },
  }
</script>

<style scoped>

</style>
